import { useVetisStore } from "entities/vetis";
import { useState } from "react";
import { useForm } from "react-hook-form";


type VetisAccessBusinessFormValues = {
  login: string;
  password: string;
  apiKey: string;
  issuerId: string;
}
type VetisAccessUserFormValues = {
  login: string;
}

export const useVetisAccessDrawers = () => {
  const addBusiness = useVetisStore(s => s.addBusiness);
  const addUser = useVetisStore(s => s.addUser);
  const setIsBusinessModalOpen = useVetisStore(s => s.setBusinessDrawerOpen);
  const setIsUserModalOpen = useVetisStore(s => s.setUserDrawerOpen);

  const isBusinessModalOpen = useVetisStore(s => s.isBusinessDrawerOpen)
  const isUserModalOpen = useVetisStore(s => s.isUserDrawerOpen)
  
  const [ isLoading, setIsLoading ] = useState<boolean>(false);

  const {
    formState: {
      errors: businessErrors
    },
    control: businessControl,
    handleSubmit: businesshandleSubmit,
    reset: businessReset
  } = useForm<VetisAccessBusinessFormValues>({
    defaultValues: {
      login: '',
      password: '',
      apiKey: '',
      issuerId: '',
    }
  })
  const {
    formState: {
      errors: userErrors
    },
    control: userControl,
    handleSubmit: userhandleSubmit,
    reset: userReset
  } = useForm<VetisAccessUserFormValues>({
    defaultValues: {
      login: '',
    }
  })

  const onBusinessClose = () => {
    if (isLoading) return;
    setIsBusinessModalOpen(false);
  }
  const onUserClose = () => {
    if (isLoading) return;
    setIsUserModalOpen(false);
  }

  const onReset = () => {
    if (isLoading) return;
    onBusinessClose();
    onUserClose();
    businessReset();
    userReset();
  }

  const onBusinessSubmit = async (data: VetisAccessBusinessFormValues) => {
    setIsLoading(true);
    await addBusiness(data);
    onBusinessClose();
    businessReset();
    setIsLoading(false);
  }

  const onUserSubmit = async (data: VetisAccessUserFormValues) => {
    setIsLoading(true);
    await addUser(data);
    onUserClose();
    userReset();
    setIsLoading(false);
  }

  return {
    isLoading,

    isBusinessModalOpen,
    businessControl,
    businessErrors,

    isUserModalOpen,
    userControl,
    userErrors,

    businesshandleSubmit,
    onBusinessClose,
    onBusinessSubmit,

    userhandleSubmit,
    onUserClose,
    onUserSubmit,

    onReset,
  }
}